import { DetailsHeader, DetailsList, Selection, IDetailsHeaderProps, IDetailsHeaderStyles, IRenderFunction, MarqueeSelection, ProgressIndicator, Stack, useTheme, IColumn, SelectionMode, DetailsListLayoutMode, IDetailsColumnStyles, Link, Icon } from '@fluentui/react';
import * as React from 'react';
import { IInvoiceItemList } from '../../../Models/Invoice/IInvoiceList';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { formatUrl } from '../../../Services/API/ApiHelpers';
import { backendUrl } from '../../../Services/ConfigureService';
import { PageTitle } from '../../PageTitle';

interface IMyInvoicesViewProps {
    items: IInvoiceItemList[];
    selectItem: (id: number) => void;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
}

export const MyInvoicesView: React.FunctionComponent<IMyInvoicesViewProps> = (props) => {

    const [selected, setSelected] = React.useState<IInvoiceItemList[]>([]);
    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IInvoiceItemList[];
            setSelected(selected);
        },
    }));

    const theme = useTheme();

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    React.useEffect(() => {
        if (selected.length > 0) {
            // props.selectItem(selected[0]);
        }
    }, [selected])

    const _columns: IColumn[] = [
        { key: 'id', name: 'Doklad', fieldName: 'id', minWidth: 80, maxWidth: 110, isResizable: true, styles: headerStyle },
        { key: 'variabil', isCollapsible: true, name: 'Variabil.', fieldName: 'variabil', minWidth: 80, maxWidth: 110, isResizable: true, styles: headerStyle },
        { key: 'created', isCollapsible: true, name: 'Vystavena', fieldName: 'created', minWidth: 80, maxWidth: 110, isResizable: true, styles: headerStyle },
        { key: 'due', name: 'Splatnost', fieldName: 'due', minWidth: 60, maxWidth: 100, isResizable: true, styles: headerStyle },
        {key: 'invoiceValue', isCollapsible: true, name: 'Částka', fieldName: 'invoiceValue', minWidth: 80, maxWidth: 110, isResizable: true, styles: headerStyle },
        { key: 'invoicePaid', isCollapsible: true, name: 'Zaplaceno', fieldName: 'invoicePaid', minWidth: 80, maxWidth: 110, isResizable: true, styles: headerStyle },
        { key: 'paid', isCollapsible: true, name: 'Zaplaceno dne', fieldName: 'paid', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
        { key: 'downloadButton', name: "zaplatit", minWidth: 50, isIconOnly: true },
    ];

    const renderItemColumn = (item: IInvoiceItemList, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IInvoiceItemList];
            switch (column.key) {
                case 'id':
                    return <span style={{
                        height: '100%', display: 'flex', fontSize: 14,
                        alignItems: 'center'
                    }}>{item.invoiceNo}</span>;
                case 'downloadButton':
                    return <div><Link target="_black" href={formatUrl(backendUrl(), `/api/pdf/GetInvoice?invoiceId=` + item?.id)}><Icon styles={{ root: { fontSize: 16 } }} iconName="DownloadDocument" title="Stáhnout fakturu" /></Link ></div>;
                case 'created':
                    return <div>{item.created.getDate() + ". " + item.created.getMonth() + ". " + item.created.getFullYear()}</div>;
                case 'due':
                    return <div>{item.due.getDate() + ". " + item.due.getMonth() + ". " + item.due.getFullYear()}</div>;
                case 'paid':
                    return <div>{item.paid.getFullYear() === 1901 ? "Nezaplaceno" : item.paid.getDate() + ". " + item.paid.getMonth() + ". " + item.paid.getFullYear()}</div>;
              default:
                    return <span style={{
                        height: '100%', display: 'flex', fontSize: 14,
                        alignItems: 'center'
                    }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }


    return (<Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
        <PageTitle title="Moje faktury" />
        <Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>
        <MarqueeSelection selection={selectionState}>
            <DetailsList
                items={props.items}
                columns={_columns}
                setKey="set"
                onRenderDetailsHeader={onRenderDetailsHeader}
                selectionMode={SelectionMode.single}
                layoutMode={DetailsListLayoutMode.justified}
                onRenderItemColumn={renderItemColumn}
                selection={selectionState}
                selectionPreservedOnEmptyClick={false}
                ariaLabelForSelectionColumn="Výběr události"
                ariaLabelForSelectAllCheckbox="Výběr události"
                checkButtonAriaLabel="Vyber řádek"
                onItemInvoked={(item: IInvoiceItemList) => props.selectItem(item.id)}
            />
        </MarqueeSelection>
    </Stack>)
}
